export const main = {
  display: "grid",
  gridTemplateColumns: "1fr 4fr",
  padding: "0px 40px",
  columnGap: '30px'
};
